import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Text, Image, ImageFit, Stack, StackItem } from '@fluentui/react';
import IAuth from '../../hooks/auth/IAuth';

import logo from '../../assets/logo-mymov-coral.png';
import background from '../../assets/background.png';

interface IPublicLayoutProps {
    auth: IAuth;
    children: JSX.Element;
    showRegistry: boolean;
};

const PublicLayout = (props: IPublicLayoutProps) => {
    const navigate = useNavigate();

    useEffect(() => {
        const script1 : HTMLScriptElement = document.createElement('script');
        script1.src = "https://www.googletagmanager.com/gtag/js?id=G-4GG77XYHG6";
        script1.async = true;
        document.body.appendChild(script1);

        const script2 : HTMLScriptElement = document.createElement('script');
        script2.append("window.dataLayer = window.dataLayer || []; function gtag() { dataLayer.push(arguments); } gtag('js', new Date()); gtag('config', 'G-4GG77XYHG6');");
        document.body.appendChild(script2);

        const script3 : HTMLScriptElement = document.createElement('script');
        script3.append("(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)}; h._hjSettings={hjid:3268939,hjsv:6}; a=o.getElementsByTagName('head')[0]; r=o.createElement('script');r.async=1; r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv; a.appendChild(r); })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');");
        document.body.appendChild(script3);

        return () => {
            document.body.removeChild(script1);
            document.body.removeChild(script2);
            document.body.removeChild(script3);
        };
    }, []);

    useEffect(() => {
        if (props.auth.user) {
            if (props.auth.user.ModoBienvenida || props.auth.user.VerPantallaInicio) {
                navigate('/main/bienvenida');
            }
            else {
                if (!props.auth.user.UsuarioAdmin) {
                    navigate('/main/ordenes-trabajo');
                }
                else {
                    navigate('/main/resumen-actividad');
                }
            }
        }
    }, [props.auth.user, navigate]);
    
    return (
        <div className="container-fluid h-100 p-0">
            <Stack 
                horizontal={true}
                className='row align-items-center m-0 h-100'>
                <StackItem className='col-12 col-lg-7 p-0 h-100 d-none d-lg-block'>
                    <Image 
                        src={background}
                        alt="MyMov"
                        height="100vh"
                        imageFit={ImageFit.cover} />
                </StackItem>
                <StackItem className='col-12 col-lg-5 p-5 p-lg-2 p-xl-5 h-100 overflow-auto d-flex flex-column justify-content-between'>
                    <div className='d-flex flex-column flex-fill justify-content-center'>
                        <div className='mb-3'>
                            <Image
                                height="90px"
                                src={logo}
                                alt="Logo" />
                        </div>
                        {props.children}
                    </div>
                    <Stack>
                        {
                            props.showRegistry ? (
                                <StackItem className='mb-3'>
                                    <Link 
                                        to="/registro-profesional"
                                        style={{
                                            color: 'var(--color-primario)',
                                            textDecoration: 'none',
                                        }}>
                                        ¿Eres un profesional? Regístrate aquí
                                    </Link>
                                </StackItem>
                            ) : (
                                null
                            )
                        }
                        <StackItem>
                            <Text>
                                &copy; 2022 AMEDIDA TI S.L. - Todos los derechos reservados
                            </Text>
                        </StackItem>
                    </Stack>
                </StackItem>
            </Stack>
        </div>
    );
};

export default PublicLayout;
